import { render, staticRenderFns } from "./AppMeta.vue?vue&type=template&id=4c7a774c"
import script from "./AppMeta.vue?vue&type=script&lang=js"
export * from "./AppMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports